import axios from 'axios'
import qs from 'qs'

import { env } from '../../utils/env'
import { LocalStorageService } from '../../utils/local-storage-service/local-storage-service'

export const http = axios.create({
  paramsSerializer: (params) => {
    const filteredParams = Object.fromEntries(Object.entries(params).filter(([, value]) => value !== null && value !== undefined))

    return qs.stringify(filteredParams, { arrayFormat: 'brackets' })
  },
  baseURL: env('API_URL'),
})

http.interceptors.request.use((config) => {
  const user = LocalStorageService.get('user')
  const token = user?.state?.user?.token
  if (token) {
    config.headers.Authorization = `Token ${token}`
  }

  return config
})
